<script setup>
import PageHead from "@/components/PageHead/PageHead.vue";
import Width from "@/pages/Index/Width.vue";
import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";
import {computed, onMounted, ref, watch} from "vue";
import Contact from "./components/Contact.vue";
import Job from "@/pages/BusinessCooperation/components/Job.vue";
import {pageBg} from "@/constant";

const store = useStore()
const router = useRouter()
const route = useRoute()

const activeTab = ref(1)

const getActiveTab = computed(() => route.query.tab ? route.query.tab / 1 : 1)

watch(
	() => getActiveTab.value,
	(n) => {
		activeTab.value = n
	},
	{
		immediate: true
	}
)
</script>

<template>
	<div
		class="business"
	>
		<PageHead
			:bg-image="pageBg.businessBg"
			:title="$t('header.Contact')"
		/>
		
		<div
			class="business__content"
		>
			<Width>
				<el-tabs
					v-model="activeTab"
					class="news__content__tab"
				>
					<el-tab-pane
						:label="$t('contact.tab.business')"
						:name="1"
					/>
					
					<el-tab-pane
						:label="$t('contact.tab.job')"
						:name="2"
					/>
				</el-tabs>
				
				<div class="business__content__info">
					<Contact
						v-if="activeTab === 1"
					/>
					
					<Job
						v-if="activeTab === 2"
					/>
				</div>
			</Width>
		</div>
	</div>
</template>

<style scoped lang="less">
.business {
	background-color: #F5F5F5;
	
	&__content {
		padding-top: 42px;
		
		&__info {
			padding: 72px 0;
		}
		
	}
	
	::v-deep(.el-tabs__item) {
		color: #3D3D3D;
		font-size: 20px;
		
		.is-active {
			font-weight: bold;
		}
		
	}
	
	::v-deep(.el-tabs__nav) {
		
		.is-active {
			color: @primary-color;
			font-weight: bold;
		}
		
		.el-tabs__active-bar {
			background-color: @primary-color;
		}
	}
}

@media only screen and (max-width: 1024px) {
	.business {
		
		&__content {
			padding: 30px 0;
			
			&__info {
				padding: 10px 0 0 0;
			}
			
		}
	}
}
</style>